import { AfterViewInit, Component, ElementRef, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { UtilsService } from 'src/app/shared/services/utils/utils.service';
import * as _ from 'lodash';

@Component({
    selector: 'app-litmus-search',
    templateUrl: './litmus-search.component.html',
    styleUrls: ['./litmus-search.component.scss'],
    standalone: false
})
export class LitmusSearchComponent implements OnInit, OnChanges, AfterViewInit {
  @ViewChild('litmussearchdropdown') litmussearchdropdown!: ElementRef;
  @Input() props: any = {};
  @Input() selectedOption: any = {}
  @Input() disabled: boolean = false
  @Input() value:any;
  @Output() change: any = new EventEmitter<any>()

  isDropdownOpen: boolean = false;
  options: any = [];
  
  isDisabled: boolean = false;
  container: any
  ddList: any;
  ddButton: any;
  isDataLoaded:boolean = false;
  constructor(private _utils: UtilsService) { }
  ngOnInit(): void {

  }

  ngOnChanges(changes: SimpleChanges): void {
    this.props = (typeof this.props ==  'string')?JSON.parse(this.props):this.props;
    this.selectedOption = (typeof this.selectedOption == 'string')?JSON.parse(this.selectedOption):this.selectedOption;
    this.value = (this.selectedOption && this.selectedOption.value)?this.selectedOption.value:null;
    this.initData(this.props)
  }

  ngAfterViewInit(): void {
    document.addEventListener('click', (event) => {
      if (this.litmussearchdropdown && this.litmussearchdropdown.nativeElement !== event.target && !this.litmussearchdropdown.nativeElement.contains(event.target)) {
        this.isDropdownOpen = false;
      }
    });
  }

  initData(props: any) {
    this.isDisabled = _.get(props, 'isDisabled', false)||this.disabled;
    this.selectedOption = _.get(props, 'selectedOption', {});
    this.options = Helpers.deepClone(props.options)
  }

  openDropdownMenu(event: any) {
    event.preventDefault()
    this.isDataLoaded = false
    if (!this.isDropdownOpen) {
      event.target.value = '';
      this.isDropdownOpen = true;
      this.search(event)
      setTimeout(() => {
        const searchInput: any = document.getElementById('ltms-search-input');
        if (searchInput) {
          searchInput.value = "";
          searchInput.focus();
        }
      }, 0);
    }else{
      this.isDataLoaded = true
    }
  }

  search(event: any) {
    event.stopPropagation();
    const text = _.get(event, 'target.value');
    if (!(this.props.options && this.props.options.length)) {
      let params = Helpers.deepClone(_.get(this.props, 'api.paramters', {}));
      let url = _.get(this.props, 'api.url');
      let method = _.get(this.props, 'api.method');

      if (!_.isEmpty(params) && url && url != "" && method && method != '') {
        params[this.props.searchfield] = text;
        this.getApiCall(url, method, params).subscribe((response: any) => {
          if (response.code == 0 && !_.isEmpty(response.data)) {
            if (this.props.api && this.props.api.parser) {
              this.options = this.props.api.parser(response);
              this.isDataLoaded = true
            } else {
              this.options = response.data
              this.isDataLoaded = true;
            }
          }
        }, (error: any) => {
          console.error("Error :", error)
          this.isDataLoaded = true
        })
      }
    } else {
      if (text != '') {
        this.options = _.filter(Helpers.deepClone(this.props.options), (option: any) => {
          return (option.name.indexOf(text) >= 0)
        })
      } else {
        {
          this.options = Helpers.deepClone(this.props.options)
        }
      }
      this.isDataLoaded = true
    }
  }

  getApiCall(url: string, method: string, params: any) {
    if (method && method.toLowerCase() == "post") {
      return this._utils.postAPICall(url, params, this._utils.setHeaderWithParams(''))
    } else {
      return this._utils.getAPICall(url, this._utils.setHeaderWithParams(params))
    }
  }

  onFieldSelect(event: any, option: any) {
    event.preventDefault();
    this.selectedOption = option;
    this.value = option.value || option.id;
    this.options = Helpers.deepClone(this.props.options)
    this.change.emit(option)
    this.isDropdownOpen = false;
  }
  clearSelection(event:any){
    event.preventDefault();
    event.stopPropagation();
    this.isDropdownOpen = false;
    this.selectedOption = {}
    this.change.emit({})
  }
}
